export const SubscriptionStatus = Object.freeze({
  ACTIVE: "active",
  TRIALING: "trialing",
  WAITING_PAYMENT: "waiting_payment",
  PENDING_PAYMENT: "pending_payment",
  UNPAID: "unpaid",
  ENDED: "ended",
  FAILED: "failed",
  REFUSED: "refused",
  CANCELED: "canceled"
});

export const SubscriptionPaymentMethod = Object.freeze({
  BOLETO: "boleto",
  PIX: "pix",
  CREDIT_CARD: "credit_card"
});

export const UserAccessType = Object.freeze({
  BLOCKED: "blocked",
  RELEASE: "release"
});

export const ButtonAction = Object.freeze({
  BLOCK: "block",
  UNBLOCK: "unblock",
  RELEASE: "release"
});

export const UserAccessHistoryTypeLabel = Object.freeze({
  release: "Liberação de acesso",
  block: "Bloqueio de acesso"
});